import { html, LitElement } from "lit";

import { websiteStyles } from "../styles/website";

import "./discorduser";

import { isMobileDevice } from "../common/client";

export class LandingComponent extends LitElement {
  constructor() {
    super();

    /** @type {LandingRateData} */
    this.landing = null;
  }

  static styles = [websiteStyles];

  render() {
    if (!this.landing) {
      return html``;
    }
    return html`<div class="row" style="cursor:default;">
      <div class="cell" style="min-width:80px;${isMobileDevice() ? "display:block;" : ""}">
        <span
          class="heading-uppercase"
          style="font-size: 12px;display:block;"
          >Landing</span
        >
        <span style="color:yellow">${new Array(5 - +this.landing.rating).fill("★").join("")}</span>
      </div>
      <div class="cell" style="min-width:100px;">
        <span
          class="heading-uppercase"
          style="font-size: 20px;${isMobileDevice() ? "display:block;margin-bottom:3px;" : ""}"
          >${this.landing.airport}</span
        >
      </div>
      <div class="cell stats">
        <span class="heading-uppercase" style="display:block;color:#CCC;font-size:12px;"
          >Landing Rate</span
        >
        <span>${Math.round(this.landing.landingRate).toLocaleString()} feet p/m</span>
      </div>
      <div class="cell players">
        <discord-user-component .userID=${this.landing.userid}></discord-user-component>
      </div>
    </div>`;
  }
}

window.customElements.define("landing-component", LandingComponent);
